export default __webpack_public_path__ + "static/media/exp3.d3b8543f.png";